module.exports = __webpack_public_path__ + "static/images/live-img-h.efd6f4320.png";